export const locale = {
	lang: 'en_EN',
	data: {
		en_EN: 'EN',
		fr_FR: 'FR',
		es_ES: 'ES',
		pt_PT: 'PT',

		welcome: 'Welcome',
		hello: 'Hello',
		insert_email_login: 'Insert e-mail to login',
		insert_phone_login: 'Insert phone number to login',
		next: 'Next',
		auth_phone: 'Or authenticate via phone',
		auth_email: "Or authenticate via e-mail",
		no_account_login: "Don't have an account?",
		register: 'Register',
		entry_catchphrase: "Don't have change? Leave it with us",
		sign_in: "Sign in",
		full_name: "Full name",
		email: "E-mail",
		phone_number: "Phone number",
		already_have_account: "Already have an account?",
		confirmation_code_title: 'Confirmation code',
		confirmation_code_instruction_email: 'Enter the confirmation code received in your e-mail to login',
		confirmation_code_instruction_phone: 'Enter the confirmation code received via SMS on your phone to login',
		code_did_not_recieve: 'Did not recieve code?',
		code_resend: 'Resend code',

		code_sent_success_email: 'Confirmation code sent to your email.',
		code_sent_success_sms: 'Confirmation code sent to your phone.',
		code_resend_info: 'Confirmation code resent.',
		code_resend_error: 'There was an error resending the confirmation code. Please try again.',
		code_confirm_no_cred: 'No credentials provided for confirmation.',
		code_confirm_error: 'There was an error confirming the code. Please try again.',
		code_confirm_invalid_error:'The code entered is incorrect.',

		login: 'Login',
		not_received_code: "Didn't receive the code?",
		resend_code: 'Resend',
		or_authenticate: 'Or authenticate via',
		via_phone: 'via phone',
		via_email: "via e-mail",
		confirm: "Confirm",
		invalid_field: "Invalid field",
		field_required: "This field is required",

		field_too_short: "Field is too short",
		field_too_long: "Field is too long",
		field_invalid_email: "Invalid email format",
		field_invalid_phone: "Invalid phone number format",
		with_another_method: "with another method",
		wrong_code: "The code you entered is incorrect",
		remaining_attempt: "Remaining attempts: ",

		movements: 'Movements',
		use_balance: 'Use',
		back_to_top: 'Back to top',

		login_error: 'Login failed. Please try again.',
		login_invalid_error: 'Invalid login credentials. Please check your information.',
		login_user_not_found_error: 'User not found.  Please check your information.',
		signup_error: 'Registration failed. Please try again.',
		signup_user_already_exists_error: 'Phone number already exists. Please use a different number or login.',
		signup_invalid_error: 'Invalid registration data. Please check your information.',

		location_not_authorized_warning: 'Location access not authorized. Please enable location permissions to find nearby points of sale.',

		points_of_sale_error: 'Failed to load nearby points of sale. Please try again.',

		session_expired_error: 'Session expired. Please, log in again.',

		no_options_select: 'No options available',
		select_country: 'Select country',

		page_not_found: 'Page not found',
		page_not_found_description: 'The page you are looking for does not exist, or another error occured. Go back, or head back to the home page by clicking the button below.',
		return:'Return',

		balance: 'Balance',
		add_balance: 'Add Balance',
		add_card: 'Add Card',

		read_qr_code: 'Read QR code',
		read_qr_code_instructions: 'Bring your smartphone close to the machine to read the QR code.',
		add_physical_card: 'Add physical card',
		pass_card: 'Swipe card',
		pass_card_instructions: 'Swipe your physical card on the machine reader to proceed.',
		confirm_card: 'Confirm card',
		confirm_card_instructions: 'Swipe the card through the machine reader again to confirm your data.',
		finish_card: 'Card Added',
		add_another_card: 'Add another card',
		finish: 'Finished',
		finish_card_instructions: 'Your card has been successfully added to your digital wallet.',
		cancel: 'Cancel',

		subdomain_not_found: 'No subdomain found or invalid subdomain',
		subdomain_not_found_description: 'A valid subdomain could not be found, the URL inserted must contain a valid subdomain.',

		balance_use: 'Use balance',
		balance_use_page_title: 'Set the amount to be used',
		available_balance: 'Available Balance',
		approve_use: 'Approve to proceed with the operation',
		add_to_machine: 'Add Credit',

		amount_too_low: 'The inserted amount is too low',
		amount_too_high: 'The inserted amount is too high',

		identify_machine: 'Identify Machine',
		scan_qr_code: 'Scan QR Code',
		machine_code: 'Machine Code',
		insert_code: 'Insert Code',
		
		toast_error_invalid_machine: 'The machine code is invalid, or the selected card cannot be used in the machine.',

		credit_sent: 'Credit sent',
		transaction_approved: 'Transaction approved',
		go_to_home: 'Home Page',

		toast_error_transaction_get_error: 'There was an error while fetching transactions.',

		add_card_description: 'What type of card would you like to add?',
		add_virtual_card: 'Add virtual card',
		
		scan_qrcode: 'Scan QR Code',
		error_no_camera_found: 'No camera found. Please ensure your device has a camera and the necessary permissions are granted.',
		toast_info_camera_permission_required: 'Camera permission is required to scan QR codes. Please enable camera access in your device settings.',
		toast_error_no_camera_found: 'No camera found. Please ensure your device has a camera and the necessary permissions are granted.',
		
		toast_error_verifying_card: 'There was an error verifying the card.',
		toast_error_scanning_card: 'There was an error scanning the card. Please try again.',
		
		go_to_cards: 'Go to my cards',

		or_insert_code: 'or insert code',

		promos:'Rules',
		promo:'Rule',


		toast_error_fetching_cards: 'There was an error retrieving your cards.',
		
		sign_out: 'Sign out',
		dialog_signout: 'Do you want to sign out of your account?',
				
		toast_pwa_get_error: 'There was an error retrieving the wallet.',
		home_find_wallet: 'Find your Loyalty Wallet',
		loyalty_wallet_recents: 'Recent Loyalty Wallets',
		home_insert_code: 'Insert code',
		or: 'or',

		toast_error_getting_pwas: 'There was an error retrieving your most recent wallets.',

		select_recent_machines: 'Select recent machines',

		forgot_password: 'Forgot Password?',
		email_input: 'Email',
		password_input: 'Password',
		login_wallet: 'Log in',
		login_wallet_description: 'Enter your email and password to use your Wallet',
		login_button: 'Log in',
		login_no_account: 'No account?',
		login_register: 'Create an account',
		confirm_password_input: 'Confirm Password',
		signup_wallet_already_have_account: 'Already have an account?',
		signup_login: 'Log in',
		signup_wallet: 'Sign up',
		signup_wallet_description: 'Create your account.',
		signup_button: 'Sign up',
		reset_password: 'Reset Password',
		reset_password_description: 'Reset your password by entering your email',
		reset_password_button: 'Reset Password',
		reset_login: 'Log in',
		reset_password_verified_email: 'If your email is registered, you will receive an email to reset your password.',

		toast_signup_email_sent: 'An email has been sent to verify your account.',
		toast_success_reset_password: 'If you have an account, we have sent you an email with further instructions.',

		error_email_invalid: 'Email is invalid.',
		error_email_required: 'Email is required.',

		error_password_required: 'Password is required.',
		error_password_too_short: 'Password is too short.',
		error_password_mismatch: 'Passwords must match.',

		toast_error_login_invalid: 'Invalid email or password.',

		server_unreachable: 'Unable to reach the server. Please check your connection and try again.'
		},
};
